module.exports = __webpack_public_path__ + "static/_48hikaru214-bdbf9794b6961b50c8df6ed5b6ab4e0d.jpg";